<template>
    <span>
        <v-dialog
                :value.sync="dialog"
                :fullscreen="fullscreen"
                transition="dialog-bottom-transition"
                :overlay="false"
                :persistent="true"
                max-width="600px"
                scrollable
                style="display: inline;"
        >
            <v-card tile>
                <v-toolbar card>
                    <v-btn icon @click.native="dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title v-text="title"></v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <slot name="content"></slot>

                    <v-btn color="primary" class="right" v-t="okLabel" @click="ok"></v-btn>
                    <v-btn v-t="cancelLabel" class="right" flat @click="cancel"></v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>

        <span ref="activator" id="activator">
            <slot name="activator"></slot>
        </span>
    </span>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            },
            width: {
                type: String,
                default: 'auto'
            },
            fullscreen: {
                type: Boolean,
                default: false
            },
            value: {
                type: Boolean,
                default: false
            },
            okLabel: {
                type: String,
                default: 'ok'
            },
            cancelLabel: {
                type: String,
                default: 'cancel'
            }
        },
        data: () => ({
            dialog: false
        }),
        watch: {
            value() {
                this.dialog = this.value;
            },
            dialog() {
                this.$emit('update:value', this.dialog);
            }
        },
        mounted() {
            this.dialog = this.value;

            if (this.$refs.activator.children.length > 0) {
                this.$refs.activator.children[0].onclick = () => {
                    this.dialog = true;
                };
            }
        },
        methods: {
            ok() {
                this.$emit('ok');
                this.dialog = false;
            },
            cancel() {
                this.$emit('cancel');
                this.dialog = false;
            }
        }
    }
</script>

<style scoped>
    #activator {
        cursor: pointer;
    }
</style>